






































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Step } from '@/interfaces/Step';
import { Responsible } from '@/interfaces/Responsible';
import { Role } from '@/interfaces/Role';
import LanguageTextInput from '@/components/App/LanguageTextInput.vue';

@Component({
  components: { LanguageTextInput }
})
export default class ModuleStepListStepResponsibleTab extends Vue {
  @Prop()
  restrictedUser!: boolean;

  @Prop()
  step!: Step;

  @Prop()
  defaultStep!: Step;

  @Prop()
  environmentSpecific!: number;

  get stepResponsibleIdPlaceholder() {
    const responsible = this.$store.state.all_responsibles.find(
      (r: Responsible) => r.id === this.defaultStep?.responsible_id
    );

    if (responsible?.name) return responsible.name;
    return '';
  }

  get stepInfotoIdPlaceholder() {
    const responsible = this.$store.state.all_responsibles.find(
      (r: Responsible) => r.id === this.defaultStep?.infoto_id
    );

    if (responsible?.name) return responsible.name;
    return '';
  }

  get stepSupportResponsibleIdPlaceholder() {
    const responsible = this.$store.state.all_responsibles.find(
      (r: Responsible) => r.id === this.defaultStep?.supportresponsible_id
    );

    if (responsible?.name) return responsible.name;
    return '';
  }

  get stepSupportRoleIdPlaceholder() {
    const role = this.$store.state.all_roles.find(
      (_role: Role) => _role.id === this?.defaultStep?.supportrole_id
    );
    if (role?.name) return role.name;
    return '';
  }

  get stepRoleIdPlaceholder() {
    const role = this.$store.state.all_roles.find(
      (_role: Role) => _role.id === this?.defaultStep?.role_id
    );
    if (role?.name) return role.name;
    return '';
  }

  get stepInfotoRoleIdPlaceholder() {
    const role = this.$store.state.all_roles.find(
      (_role: Role) => _role.id === this?.defaultStep?.infotorole_id
    );
    if (role?.name) return role.name;
    return '';
  }
}
